import { render, staticRenderFns } from "./detail-header.vue?vue&type=template&id=9992c79a&scoped=true&"
import script from "./detail-header.vue?vue&type=script&lang=js&"
export * from "./detail-header.vue?vue&type=script&lang=js&"
import style0 from "./detail-header.vue?vue&type=style&index=0&id=9992c79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9992c79a",
  null
  
)

export default component.exports